import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { UIContext } from '../../../Context/UIContext'

const Waves = () => {
    const { isTablet } = useContext(UIContext)
    const drawWave = (color) => {
        return {
            hidden: (i) => { 
                return {
                    pathLength: 0,
                    fill: '#FFFFFF',
                    fillOpacity: 0,
                    stroke: '#FFFFFF',
                    opacity: 0
                }
            },
            visible: (i) => {
                let stroke = color
                const strokeDelay = i * 0.5
                const fillDelay = isTablet ? 0.75 : strokeDelay + 0.5
                const transition = {
                    pathLength: { delay: strokeDelay, duration: i === 2 ? 2.5 : 2, ease: "easeInOut" },
                    opacity: { delay: strokeDelay, duration: 0.1 },
                    fillOpacity: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                    fill: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                }
                if (i === 2) {
                    transition.stroke = { delay: strokeDelay, duration: 2.5, ease: "easeInOut" }
                    stroke = ['#FFFFFF', color]
                }
                return {
                    pathLength: 1.1,
                    fill: color,
                    fillOpacity: 1,
                    stroke,
                    opacity: 1,
                    pathOffset: 0,
                    transition,
                }
            },
        }
    }
    
    return (
        <>
            { isTablet ?
                <motion.svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 375 218"
                    key="home-section-main-waves"
                    className="mga-home-section__main__bg"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.1 }}
                    style={{ 
                        fillRule: "evenodd", 
                        clipRule: "evenodd", 
                        strokeLinejoin: "round", 
                        strokeMiterlimit: 2,
                        strokeWidth: 0.2
                    }}
                >
                    <defs>
                        <clipPath id="a">
                            <path transform="translate(0 594)" fill="#fff" d="M0 0h375v218H0z"/>
                        </clipPath>
                    </defs>
                    <g transform="translate(0 -594)" clipPath="url(#a)">
                        <motion.path 
                            d="M132.15 664.056C-126.242 670.081-81.224 811.372-1.942 817.447c203.285 15.578 213.95 44.153 319.86 87.848 147.512 60.856 195.025 62.146 217.553 37.72s.124-93.325-30.066-134.005S390.547 658.031 132.15 664.056"
                            stroke="#FFFFFF"
                            fill="#FFFFFF"
                            variants={drawWave("#EF7D10")}
                            initial="hidden"
                            animate="visible"
                            custom={2}
                            style={{
                                fillRule: "nonzero"
                            }}
                        />
                        <motion.path
                            d="M241.541 602.926c-258.392 6.025-508.023 83.35-508.023 83.35 347.124-10.193 574.032 44.301 721.538 105.158s167.278 114.88 189.807 90.45.124-93.324-30.066-134.004S499.938 596.901 241.54 602.926"
                            stroke="#E9540D"
                            fill="#FFFFFF"
                            variants={drawWave("#E9540D")}
                            initial="hidden"
                            animate="visible"
                            custom={0}
                            style={{
                                fillRule: "nonzero",
                            }}
                        />
                    </g>
                </motion.svg>
            : 
                <motion.svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 160"
                    key="home-section-main-waves"
                    className="mga-home-section__main__bg"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.1 }}
                    style={{ 
                        fillRule: "evenodd", 
                        clipRule: "evenodd", 
                        strokeLinejoin: "round", 
                        strokeMiterlimit: 2,
                        strokeWidth: 0.2
                    }}
                >
                    <motion.path
                        d="M47.293 160.342S215.56 57.249 587.24 15.453s680.416 14.432 680.416 14.432v135.816z"
                        stroke="#E9540D"
                        fill="#FFFFFF"
                        variants={drawWave("#E9540D")}
                        initial="hidden"
                        animate="visible"
                        custom={0}
                        style={{
                            fillRule: "nonzero",
                        }}
                    />
                    <motion.path
                        d="M21.356 153.963S224.408 45.404 625.84 42.833s625.908 71.307 625.908 71.307v48.143H0z"
                        stroke="#FFFFFF"
                        fill="#FFFFFF"
                        variants={drawWave("#EF7D10")}
                        initial="hidden"
                        animate="visible"
                        custom={2}
                        style={{
                            fillRule: "nonzero"
                        }}
                    />
                </motion.svg>
            }
        </>
    )
}

export default React.memo(Waves)